import { CardButton } from './CardButton';

// TODO: in v9, move styled() from CardButton.jsx to here
export var StyledCardButton = CardButton;